import { Outlet, useLocation, useOutletContext } from "react-router-dom";
import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { paymentItemsTabs } from "../../../../assets/utils/data/onboarding";
import { COLORS } from "../../../../assets/utils/enums/colors";
import { LittleSubHeadline, NotificationText, SubTitle } from "../../../../components/typography";
import { StyledTab, TabList, Underline } from "../../../finance/main";
import { FixedBodyDiv, TitleSpan } from "../team/view-team";
import { LoaderOutletContext } from "../basket/main";

export default function PaymentSettingsTab() {
    const { setLoaderState } =
        useOutletContext<LoaderOutletContext>();
    const location = useLocation();

    return (
        <FixedBodyDiv
            className={`w-60 ${SETTINGS_BODY_DIV}`}
            $isPadding={true}
        >
            <TitleSpan>
                <SubTitle>Підписка та оплата</SubTitle>
                <NotificationText>Керуйте тарифом, способом оплати та переглядайте історію платежів.</NotificationText>
            </TitleSpan>

            <TabList key="tabs-payment" className="flex-grow-0 w-100 justify-content-between">
                {paymentItemsTabs.map((item) =>
                    <StyledTab
                        to={item.id}
                        key={item.id}
                        className={`p-0 ${(isActive: boolean) => (isActive ? "active" : "")}`}
                        $color={COLORS.blue}
                    >
                        <LittleSubHeadline>{item.name}</LittleSubHeadline>
                        {location.pathname === `/settings/payment/${item.id}` && (
                            <Underline $color={COLORS.blue} layoutId="underline" />
                        )}
                    </StyledTab>)}

            </TabList>

            <Outlet context={{ setLoaderState }} />
        </FixedBodyDiv>
    )
}